import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=0e95ddf2&lang=pug&"
import script from "./CreateProduct.vue?vue&type=script&lang=ts&"
export * from "./CreateProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&id=0e95ddf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports